/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LoginFoundationAliases {
  AVATAR_LOGIN = 'avatar-login',
  ESTABLISHMENT_PANEL = 'establishment-panel',
  ESTABLISHMENT_TEXT = 'establishment-text',
  LAYOUT_LOGIN_FOUNDATION = 'layout-login-foundation',
  LOCATION_IMAGE = 'location-image',
  LOGIN_FOUNDATION = 'login-foundation',
  PANEL_LOGIN = 'panel-login',
  PANEL_RESOLUTION = 'panel-resolution',
  TEXT_RESOLUTION_SUPORTED = 'text-resolution-suported',
}
export { LoginFoundationAliases };
